import LazyImage from "../components/LazyImage";
import rmz from "../assets/images/RMZ6.png?w=600;900;1200;1800&format=webp&quality=75&effort=6&as=picture";

const Custom = () => (
  <div className="lg:flex p-10">
    <div className="flex-col mr-4">
      <h1 className="title romanStandard text-sm">Custom design</h1>
      <p className="text-justify w-[300px] romanStandard">
        Our top quality service ensures that your bike looks the way you want it
        1st time, our innovative design makes that happen. We can access most
        manufacturer bikes templates from the 80s bikes right up to the latest
        bikes; this enables us to reproduce vintage and early model decals for
        your motocross bike along with the latest designs for your new bike
      </p>
    </div>
    <LazyImage
      src={rmz.img.src}
      srcSet={rmz.sources.webp}
      sizes="(min-width: 1024px) 50vw, 90vw"
      width={rmz.img.w}
      height={rmz.img.h}
      alt="Suzuki RM-Z with a custom Motographic graphics kit"
      className="lg:w-1/2 lg:ml-auto pt-10 lg:pt-0"
    />
  </div>
);

export default Custom;
